import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { withBooking } from 'components/queries/GetBookingQuery';
import AmendBooking from './AmendBooking';

export default withRouter(withBooking(injectIntl(AmendBooking)));
